// eslint-disable-next-line no-restricted-imports
import type {useToastContext} from '@github-ui/toast/ToastContext'

interface NotificationOptions {
  message?: string
}

/**
 * Function to be used from React components that have access to ToastContext
 * Call this from within a React component to use toast notifications
 */
export function showVersionMismatchToast(
  toastContext: ReturnType<typeof useToastContext>,
  options: NotificationOptions = {},
): void {
  const {message = 'A new version of GitHub is available. Please refresh the page.'} = options

  // eslint-disable-next-line @github-ui/dotcom-primer/toast-migration
  toastContext.addPersistedToast({
    type: 'info',
    message,
    role: 'alert',
  })
}
